require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-poll-where-should-code-fellows-expand-to-next.json") })
        }
      }, "path---blog-poll-where-should-code-fellows-expand-to-next");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-poll-where-should-code-fellows-expand-to-next!./.cache/json/blog-poll-where-should-code-fellows-expand-to-next.json
// module id = 1046
// module chunks = 231608221292675